<template>
  <div class="homeContainerRefuge">

    <div class="underLogoPhrase">
      <h2 class="font-weight-bold mb-4 centers">La Boutique</h2>
      <p class="littlesize">
        Notre boutique est une source de revenus primordiale pour l'association.
        <br>
        Les produits ci-dessous sont disponibles au refuge.
      </p>
    </div>

    <!-- IFRAME DIRECT EN BRUT -->
    <iframe
      id="iframe_assoconnect"
      src="https://alma-6325d4c97bfcb.assoconnect.com/collect/description/639141-c-la-boutique-de-noel-alma?iframe=1"
      allow="payment"
      width="100%"
      style="overflow: hidden; border: 0; max-height: none;"
      scrolling="no"
      onload="window.location.href='#iframe_assoconnect'">
    </iframe>

  </div>
</template>

<script>
export default {
  mounted() {
    // Adjust dynamic height sent by AssoConnect
    window.addEventListener("message", function (event) {
      if (
        event.data.action === "iframe.height" &&
        (event.origin === "https://alma-6325d4c97bfcb.assoconnect.com" ||
         event.origin === "https://pay.assoconnect.com")
      ) {
        const iframe = document.getElementById("iframe_assoconnect");
        if (iframe) iframe.height = event.data.height;
      }
    });
  }
};
</script>

<style>
#iframe_assoconnect {
  border: 0;
}
</style>
